const getProducts = (products, setProducts)=>{
    fetch("https://barelrancho.es/WebService1.asmx/leerProductos", {        
        method:'GET',
        mode:'cors'
    }).then(res => {
        res.json().then((data)=>{console.log(data); setProducts(
            ...products,
            data.records,

        )})
    }).catch((err, res) => {console.log(err)})
}

export {getProducts};
